export default import.meta.ROLLUP_FILE_URL_xUfAOc8vsLn5godiQWqFgA;